export function getManifest() {
  const name = localStorage.getItem("__CONSOLE_TITLE__");
  const icon = localStorage.getItem("__CONSOLE_IMGURL__");

  var myDynamicManifest = {
    name: name,
    short_name: "aiot",
    start_url: process.env.VUE_APP_AIOT_HOST + "/#/home/index",
    icons: [
      {
        sizes: "114x114",
        src: icon
      },
      {
        sizes: "120x120",
        src: icon
      },
      {
        sizes: "144x144",
        src: icon
      },
      {
        sizes: "152x152",
        src: icon
      },
      {
        sizes: "180x180",
        src: icon
      },
      {
        sizes: "57x57",
        src: icon
      },
      {
        sizes: "60x60",
        src: icon
      },
      {
        sizes: "72x72",
        src: icon
      },
      {
        sizes: "76x76",
        src: icon
      },
      {
        src: icon,
        type: "image/png",
        sizes: "192x192"
      },
      {
        src: icon,
        type: "image/png",
        sizes: "512x512"
      }
    ],
    display: "standalone",
    background_color: "#fff",
    theme_color: "#252a2f"
  };
  const url = localStorage.getItem("__MANIFEST__");
  destoryUrl(url);
  const stringManifest = JSON.stringify(myDynamicManifest);
  const blob = new Blob([stringManifest], { type: "application/json" });
  const manifestURL = URL.createObjectURL(blob);
  localStorage.setItem("__MANIFEST__", manifestURL);

  document
    .querySelector("#my-manifest-placeholder")
    .setAttribute("href", manifestURL);
}

function destoryUrl(url) {
  if (url) {
    URL.revokeObjectURL(url);
    url = null;
  }
}
